import React from 'react';
import { SafeAreaView, ScrollView, View } from 'react-native';
import { Modal, Portal } from 'react-native-paper';
import { useMutation } from 'react-query';

import FeedbackDialogContent from './components/feedback-dialog-content';
import FeedbackError from './components/feedback-error';
import FeedbackIconButton from './components/feedback-icon-button';
import FeedbackSuccess from './components/feedback-success';
import styles from './feedback-dialog.style';
import { useColors } from '../../hooks';
import { isBigScreen } from '../media-query';

interface FeedbackDialogProps {
  visible: boolean;
  onClose: (message?: string) => void;
  onSubmit: (message: string) => Promise<any>;
  successNode?: React.ReactNode;
  nlsKeys: {
    title: string;
    instructions: string;
    enterText: string;
    newQuestion?: string;
  };
}

export default function FeedbackDialog({
  visible,
  onClose,
  onSubmit,
  successNode,
  nlsKeys,
}: FeedbackDialogProps) {
  const colors = useColors();
  const {
    mutate: submit,
    reset,
    isLoading,
    isSuccess,
    isError,
  } = useMutation<Response, unknown, string, unknown>((message) =>
    onSubmit(message)
  );

  return (
    <Portal>
      <Modal
        visible={visible}
        contentContainerStyle={[
          styles.modalContent,
          { backgroundColor: colors.grayLight },
        ]}
        dismissable
        onDismiss={onClose}
      >
        <SafeAreaView style={styles.container}>
          {!isBigScreen() && (
            <View style={{ backgroundColor: colors.background }}>
              <FeedbackIconButton
                iconName="arrow-left"
                iconSize={24}
                style={styles.backButton}
                onPress={() => onClose()}
              />
            </View>
          )}
          <ScrollView keyboardShouldPersistTaps="handled">
            {!isSuccess && !isError && (
              <FeedbackDialogContent
                isLoading={isLoading}
                nlsKeys={nlsKeys}
                onClose={onClose}
                onSubmit={submit}
              />
            )}

            {isSuccess && (
              <FeedbackSuccess
                onClose={onClose}
                onReset={reset}
                newQuestionKey={nlsKeys.newQuestion}
              >
                {successNode}
              </FeedbackSuccess>
            )}

            {isError && <FeedbackError onClose={onClose} onTryAgain={reset} />}
          </ScrollView>
        </SafeAreaView>
      </Modal>
    </Portal>
  );
}
